<label *ngIf="volume">{{ volume.measure?.value }}: <b>{{ volume?.value ? format(volume.value) + " " + volume.unit + " (" + volume.timeframe + ")" : "-" }}</b></label>
